import React from "react";
import {Routes, Route} from 'react-router-dom'
import Contact from "./routes/Contact";
import Home from './routes/Home'
import Services from "./routes/Services";

function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={<Services />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
